var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSingleStore = function SvgSingleStore(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 261,
    viewBox: "0 0 262 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.644 0C164.606 7.77682 190.082 27.3744 200.645 51.327C216.8 90.2111 213.072 139.361 195.363 168.601C180.45 192.554 157.46 205.308 131.052 204.997C90.042 204.686 56.799 172.023 56.488 130.962C56.488 89.9 88.799 55.9931 131.052 55.9931C137.887 55.9931 147.742 56.941 158.927 61.6071C158.927 61.6071 150.886 56.8445 130.235 53.6453C70.895 45.8684 0.875983 90.8332 17.031 194.42C39.4 234.238 82.275 261.301 131.052 260.99C202.82 260.679 261.539 201.886 261.228 129.717C261.228 60.6592 204.994 1.86644 136.644 0Z",
    fill: "url(#paint0_linear_1_17)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185.421 55.0598C175.479 34.218 154.974 17.7311 129.808 11.1986C124.216 9.64319 118.313 9.02103 111.789 8.70996C102.158 8.70996 92.837 9.95429 83.206 12.4429C59.283 19.5975 42.506 33.5958 32.565 44.4833C19.827 59.1037 11.438 74.3463 6.46699 89.5889C6.46699 89.8999 6.15699 90.211 6.15699 90.8332C5.84599 92.0775 4.60298 95.8103 4.60298 96.7436C4.29198 97.3657 4.29199 98.2989 3.98199 98.9211C3.67099 100.165 3.35999 101.41 3.04999 102.654C3.04999 102.965 3.04999 103.276 2.73899 103.587C-5.33881 143.716 8.07998 179.727 16.158 193.103C18.179 196.449 19.838 199.24 21.5 201.801C3.16999 102.258 55.866 54.7488 115.828 53.5045C147.207 52.8823 178.585 65.6363 193.809 91.1442C192.877 77.146 191.945 69.3692 185.421 55.0598Z",
    fill: "url(#paint1_linear_1_17)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_17",
    x1: 216.189,
    y1: -0.0000195737,
    x2: 25.668,
    y2: 167.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403975,
    stopColor: "#AA00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0A78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_17",
    x1: 97.026,
    y1: -33.8062,
    x2: 212.821,
    y2: 83.7228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354358,
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512854,
    stopColor: "#8800CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311B92"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSingleStore);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/single-store.0da059f6a00593fad9907e60b514707b.svg";